import {createSlice} from '@reduxjs/toolkit';

type InitialState = {
  theme: null | 'light' | 'dark';
  netatmoWeather: {
    chartView: boolean;
    analysisChartView: boolean;
  };
  netatmoEnergy: {
    chartView: boolean;
    analysisChartView: boolean;
  };
  weather: {
    chartView: boolean;
  };
  gesture: {
    chart: boolean;
  };
  lastNavigator: null | 'NetatmoWeather' | 'NetatmoEnergy' | 'Weather';
  smallDecimals: boolean;
  windDirectionConvention: 'oceanographic' | 'meteorological';
  stationLayer: boolean;
  rainRadarLayer: boolean;
  lightningLayer: boolean;
};

export const initialState = {
  theme: null,
  netatmoWeather: {
    chartView: true,
    analysisChartView: false,
  },
  netatmoEnergy: {
    chartView: true,
    analysisChartView: false,
  },
  weather: {
    chartView: true,
  },
  gesture: {
    chart: false,
  },
  lastNavigator: null,
  smallDecimals: true,
  windDirectionConvention: 'oceanographic',
  stationLayer: true,
  rainRadarLayer: true,
  lightningLayer: true,
} as InitialState;

export const prefsSlice = createSlice({
  name: 'prefs',
  initialState: initialState,
  reducers: {
    setTheme: (state, {payload: theme}) => {
      state.theme = theme;
    },
    setNetatmoWeatherChartView: (
      state,
      {payload: value}: {payload: boolean},
    ) => {
      state.netatmoWeather = {...state.netatmoWeather, chartView: value};
    },
    setNetatmoWeatherAnalysisChartView: (
      state,
      {payload: value}: {payload: boolean},
    ) => {
      state.netatmoWeather = {
        ...state.netatmoWeather,
        analysisChartView: value,
      };
    },
    setNetatmoEnergyChartView: (
      state,
      {payload: value}: {payload: boolean},
    ) => {
      state.netatmoEnergy = {...state.netatmoEnergy, chartView: value};
    },
    setNetatmoEnergyAnalysisChartView: (
      state,
      {payload: value}: {payload: boolean},
    ) => {
      state.netatmoEnergy = {
        ...state.netatmoEnergy,
        analysisChartView: value,
      };
    },
    setWeatherChartView: (state, {payload: value}: {payload: boolean}) => {
      state.weather = {...state.weather, chartView: value};
    },
    setChartGesture: (state, {payload: value}: {payload: boolean}) => {
      state.gesture = {
        ...state.gesture,
        chart: value,
      };
    },
    setLastNavigator: (
      state,
      {
        payload: value,
      }: {
        payload: 'NetatmoWeather' | 'NetatmoEnergy' | 'Weather';
      },
    ) => {
      state.lastNavigator = value;
    },
    setSmallDecimals: (state, {payload: value}: {payload: boolean}) => {
      state.smallDecimals = value;
    },
    setWindDirectionConvention: (
      state,
      {payload: value}: {payload: 'oceanographic' | 'meteorological'},
    ) => {
      state.windDirectionConvention = value;
    },
    setStationLayer: (state, {payload: value}: {payload: boolean}) => {
      state.stationLayer = value;
    },
    setRainRadarLayer: (state, {payload: value}: {payload: boolean}) => {
      state.rainRadarLayer = value;
    },
    setLightningLayer: (state, {payload: value}: {payload: boolean}) => {
      state.lightningLayer = value;
    },
  },
});

export const {
  setTheme,
  setNetatmoWeatherChartView,
  setNetatmoWeatherAnalysisChartView,
  setNetatmoEnergyChartView,
  setNetatmoEnergyAnalysisChartView,
  setWeatherChartView,
  setChartGesture,
  setLastNavigator,
  setSmallDecimals,
  setWindDirectionConvention,
  setStationLayer,
  setRainRadarLayer,
  setLightningLayer,
} = prefsSlice.actions;

export default prefsSlice.reducer;
